import { useTranslation } from 'react-i18next';
import OInput from '../../../../../UI/FormControls/OInput';
import MyButton from '../../../../../UI/myButton/MyButton';
import { formatDateBody } from '../../../../../../../utils/FormatDate';

const Inputs = ({ formValues, setFormValues, handleSave }) => {
  const { t, i18n } = useTranslation();

  const handleChange = (item) => {
    if (typeof formValues[item.target.name] === 'boolean') {
      setFormValues((curr) => {
        return { ...curr, [item.target.name]: item.target.checked };
      });
    } else {
      setFormValues((curr) => {
        return { ...curr, [item.target.name]: item.target.value };
      });
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '2px',
        marginBottom: '10px',
      }}
    >
      <OInput
        label={`${t('machineHours')}`}
        name="brojCiklusa"
        value={formValues.brojCiklusa}
        handleChange={handleChange}
        style={{ width: '30%' }}
        type="number"
      />{' '}
      <OInput
        label={t('date')}
        style={{ width: '30%' }}
        handleChange={handleChange}
        type="date"
        value={formatDateBody(formValues.datum)}
        name="datum"
      />
      <MyButton
        label={t('buttons.save')}
        icon="fas fa-save"
        onClick={handleSave}
      />
    </div>
  );
};

export default Inputs;
